<template>
  <div class="icons-version-selector">
    <wa-select-custom
      label="Choose a version of Font Awesome"
      is-minimal
      @change="(value) => resolveIconRoute(value)"
    >
      <template slot="options">
        <option
          v-for="version in allVersions"
          :key="version"
          :selected="activeVersion === version"
        >
          {{ version }}
        </option>
      </template>
    </wa-select-custom>
  </div>
</template>

<script>
  import { debounce, pick, without } from 'lodash'

  const DEBOUNCE_TIMER = 350

  export default {
    name: 'VersionSelector',

    computed: {
      allVersions() {
        let versions = []
        versions.push(this.$releases.latest.v6.version)
        versions.push(this.$releases.latest.v5.version)
        versions.push('All Versions')
        return versions
      },

      activeVersion() {
        return this.$releases.active.version
      },

      latestV6version() {
        return this.$releases.latest.v6.version
      },

      latestV5version() {
        return this.$releases.latest.v5.version
      }
    },

    methods: {
      resolveIconRoute(version) {
        const query = pick(this.$route.query, ['q', 'm', 's'])

        let routeParams = { name: 'versions' }
        let versionSelection = version.split('.')

        if (versionSelection[0] === '6') {
          routeParams.name = 'six.search'
          routeParams.query = query
        } else if (versionSelection[0] === '5') {
          routeParams.name = 'five.search'
          routeParams.query = { ...query, s: this.maybeRemoveThin(query.s) }
        }

        this.$posthog.capture('icon_search:version_select_submit', { version: version })

        return window.location.replace(this.$router.resolve(routeParams).href)
      },

      maybeRemoveThin(style) {
        if (!style) {
          return undefined
        }
        const styles = style.split(',')

        return without(styles, 'thin').join(',')
      },

      inputChanged: debounce(function (event) {
        this.$emit('input', event.target.value)
      }, DEBOUNCE_TIMER)
    }
  }
</script>
